import { OAUTH_BASE_URL_GOLANG } from 'common/config';
import { createAxiosInstance } from './axios-instance';

const axiosOauthGolang = createAxiosInstance(OAUTH_BASE_URL_GOLANG); // with go-auth header
export default axiosOauthGolang;

